// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"72eb6d1d","90":"e93e1225","210":"d162adc2","216":"b55fd4e7","318":"0013e2bf","442":"e314eee2","492":"4ce2b4d8","530":"c3a9114c","711":"9baf0c97","874":"64d71c4b"}[chunkId] + ".chunk.js";
};